import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SharedService } from 'app/core/services/shared.service';
import { Router } from '@angular/router';
import { log } from 'console';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-cookie-consent-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    CommonModule,
  ],
  templateUrl: './cookie-consent-dialog.component.html',

})
export class CookieConsentDialogComponent {
  #dialogRef = inject(MatDialogRef<CookieConsentDialogComponent>);


  openLink(){
    window.open(`${environment.cookieConsentDialog}`,'_blank');
  }

  approve() {
    localStorage.setItem('cookieConsent', 'true');
    this.#dialogRef.close('approved');
  }

  disapprove() {
    localStorage.setItem('cookieConsent', 'false');
    this.#dialogRef.close('declined');
  }
}